import { calendarLabels, formatDate, parseIso, weekdayIndex } from "@altek/ui/lib/format/date";

/**
 * «İşe dönüş» — iznin ardından işe başlanacak ilk gün, kişinin okuyacağı biçimde (izin-sade,
 * 20 Ekim 2026). Kullanıcı bitiş tarihinin iznin DAHİL olduğunu görmek istedi: alanın altına
 * «son izin gününüz, izne dahil», süre kutusuna da «İşe dönüş: Pazartesi 19.10.2026».
 *
 * GÜNÜ SUNUCU BULUYOR (`returnDate`): hafta sonu, resmî tatil ve köprü günü kişinin KENDİ takviminden
 * atlanıyor — istemci «bitişin ertesi gün» demiyor. Burada yalnız söyleniş var.
 *
 * `SECOND_HALF`: izin öğlene kadar sürüyor, kişi o günün öğleden sonrasında işte.
 */
export type ReturnDayPart = "FULL" | "SECOND_HALF";

/** «Pazartesi 19.10.2026», yarım günde «Çarşamba 14.10.2026, öğleden sonra». */
export function returnDayText(
  date: string | null | undefined,
  part?: ReturnDayPart | null,
): string | null {
  const parsed = parseIso(date ?? null);
  if (!parsed) return null;
  const name = calendarLabels.daysLong[weekdayIndex(parsed)] ?? "";
  const day = `${name} ${formatDate(parsed)}`.trim();
  return part === "SECOND_HALF" ? `${day}, öğleden sonra` : day;
}
